/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geocoarsertier2Inputs */

const en_geocoarsertier2 = /** @type {(inputs: Geocoarsertier2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too little data at this zoom - showing wider areas instead.`)
};

const de_geocoarsertier2 = /** @type {(inputs: Geocoarsertier2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu wenige Daten auf dieser Zoomstufe - es werden größere Gebiete gezeigt.`)
};

/**
* | output |
* | --- |
* | "Too little data at this zoom - showing wider areas instead." |
*
* @param {Geocoarsertier2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geocoarsertier2 = /** @type {((inputs?: Geocoarsertier2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geocoarsertier2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geocoarsertier2(inputs)
	return de_geocoarsertier2(inputs)
});
export { geocoarsertier2 as "geoCoarserTier" }